import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

function loadGoogleMaps(): Promise<void> {
  if ((window as any).google?.maps) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.getElementById('google-maps-api');
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.id = 'google-maps-api'; script.async = true; script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&language=en&loading=async`;
    script.onload = () => resolve(); script.onerror = reject;
    document.head.appendChild(script);
  });
}

loadGoogleMaps()
  .catch(err => console.error('Google Maps could not be loaded.', err))
  .finally(() => bootstrapApplication(App, appConfig).catch(err => console.error(err)));
